/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function updateHeaderCartBadge() {
    let count = 0;

    // Count every quantity field currently in the drawer
    document.querySelectorAll('[data-quantity-field]').forEach(input => {
      count += parseInt(input.value, 10) || 0;
    });

    // Update ONLY the JS-driven updates (do NOT override Liquid initial load)
    document.querySelectorAll('[data-header-cart-count]').forEach(el => {
      if (count > 0) {
        el.textContent = `(${count})`; // <-- wrap in parentheses
        el.style.display = '';         // ensure visible
      } else {
        el.style.display = 'none';     // hide when count = 0
      }
    });
  }

  function initCartWatcher() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      updateHeaderCartBadge(); // recalc count whenever drawer updates
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });

    // IMPORTANT:
    // ❌ Do NOT run updateHeaderCartBadge() here on page load
    // Liquid already printed the correct initial value.
  }

  document.addEventListener('DOMContentLoaded', initCartWatcher);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
